import React from 'react';
import {
    Image,
    View,
    Text,
    Linking,
    StyleSheet,
    ScrollView,
    ImageBackground,
    TouchableOpacity,
    ToastAndroid,
    ActivityIndicator,
} from 'react-native';

import Clipboard from "@react-native-community/clipboard"

import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../../components/StyledButton';
import FormikInput from '../../components/form/FormikInput';
import GenericModal from '../../components/modals/GenericModal';
import StyledIcon from '../../components/StyledIcon';
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation, useRoute } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import WalletNavCard from '../../components/wallet/NavCard';
import WalletHistoryCard from '../../components/wallet/HistoryCard';
import OTPInputView from '@twotalltotems/react-native-otp-input'
import GenericHeader from '../../components/headers/GenericHeader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import http from '../../utils/http';
import { formatCurrency } from '../../utils/money';
// import SmsRetriever from 'react-native-sms-retriever';

const analytics = new AnalyticsService

function SendStartScreen() {
    const navigation = useNavigation()
    const route = useRoute()

    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [accountDetails, setAccountDetails] = React.useState(null)

    const [confirmBoxOpen, setConfirmBoxOpen] = React.useState(false)
    const hideConfirmModal = () => {
        setConfirmBoxOpen(false)
    }

    const formSchema = Yup.object().shape({
        amount: Yup.string()
            .matches(/\d$/, 'Enter a valid amount')
            .test('match', `You can only transfer ${formatCurrency(1000, false, true)} and above`, amount => {
                return parseInt(amount.replace(/[^0-9]+/g, '')) > 999
            })
            .required('Enter an amount'),
    });

    const initiateSend = (values, actions) => {
        let amount = parseInt(values?.amount.replace(/[^0-9]+/g, ''))*100 // in kobo
        const form = new FormData()
        form.append('model', 'buyer')
        form.append('mobile', buyer.phone)
        form.append('account_number', accountDetails?.accountNumber)
        form.append('account_bank', accountDetails?.bankCode)
        form.append('account_name', accountDetails?.accountName)
        form.append('amount', amount)
        form.append('remark', values?.remark)

        http.post('spend/eyowo_initiate_transfer', form, token)
            .then(res => {
                if (res.code === 200) {
                    // ToastAndroid.show("Bank transfer was successful", ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    actions.setSubmitting(false)
                    actions.resetForm()
                    navigation.navigate('WalletIndex')
                } else {
                    // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    actions.setSubmitting(false)
                    console.warn(res)
                }
            })
            .catch(err => {
                // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                actions.setSubmitting(false)
                console.warn(err)
            })
    }

    React.useEffect(() => {
        navigation.addListener('focus', () => {
            if (navigation.isFocused()) {
                if (route.params?.account_details) {
                    setAccountDetails({ ...route.params?.account_details })
                    analytics.logEvent('Viewed Wallet Send Money', buyer)
                    analytics.googleHelpers.setCurrentScreen('ViewedWalletSendMoney', 'ViewedWalletSendMoney')
                } else {
                    navigation.navigate('WalletSendStart')
                }
            }
        })
        return () => {
            // cleanup
            navigation.removeListener('focus')
        };
    }, []);

    return (
        <>
            <GenericHeader title="Send Money" />
            <ScrollView contentContainerStyle={styles.container}>
                {accountDetails
                    ? <Formik
                        initialValues={{
                            amount: accountDetails?.amount,
                            remark: '',
                        }}
                        validationSchema={formSchema}
                        onSubmit={(values, actions) => {
                            setConfirmBoxOpen(true)
                            // initiateSend(values, actions)
                        }}
                    >
                        {({ values, isSubmitting, isValid, submitForm, validateForm, ...props }) => <View>
                            <GenericModal
                                modalState={confirmBoxOpen}
                                hideModal={() => {
                                    hideConfirmModal()
                                    props.setSubmitting(false)
                                }}
                                icon={<View style={{ marginVertical: 20 }}>
                                    <StyledIcon iconName="md-alert" iconColor={Colors.warningBackground} iconOnly size={50} style={{ marginTop: 40 }} />
                                </View>}
                                message={`Do you want to send ${values?.amount} to ${accountDetails?.accountName}? `}
                                buttons={[
                                    {
                                        type: 'default',
                                        label: 'Yes, proceed',
                                        fluid: false,
                                        action: () => {
                                            hideConfirmModal()
                                            // submitForm()
                                            initiateSend(values, { isSubmitting, isValid, submitForm, validateForm, ...props })
                                        }
                                    },
                                    {
                                        type: 'danger',
                                        label: 'Cancel',
                                        fluid: false,
                                    }
                                ]}
                            />
                            <View style={[
                                styles.subHeader,
                                {
                                    flexDirection: 'row',
                                    marginBottom: 10,
                                    paddingTop: 16,
                                    backgroundColor: Colors.whiteColor,
                                }
                            ]}>
                                <Image
                                    source={require('../../assets/images/main/user.png')}
                                    style={{
                                        width: 30,
                                        height: 34,
                                        marginRight: 16,
                                        alignSelf: 'center'
                                    }}
                                />
                                <View>
                                    <Text style={[
                                        FontStyles.size14,
                                        FontStyles.lh16,
                                        FontStyles.gray,
                                        styles.subHeaderText,
                                    ]}>Send To:</Text>

                                    <Text style={[
                                        FontStyles.size16,
                                        FontStyles.lh20,
                                        styles.subHeaderText,
                                        { marginTop: 6 }
                                    ]}>{accountDetails?.accountName}</Text>

                                    <Text style={[
                                        FontStyles.size14,
                                        FontStyles.lh18,
                                        FontStyles.gray,
                                        styles.subHeaderText,
                                        { marginTop: 4 }
                                    ]}>{accountDetails?.bankName}</Text>

                                </View>
                            </View>

                            <View style={styles.formContainer}>
                                <FormikInput
                                    label="Amount"
                                    fieldName="amount"
                                    placeholder="Enter amount"
                                    isCurrency
                                />
                                <FormikInput
                                    fieldName="remark"
                                    label="Remark"
                                    placeholder="Enter transaction remark"
                                    // numberOfLines={2}
                                />

                                <Text style={[
                                    FontStyles.size14,
                                    FontStyles.lh18,
                                    FontStyles.gray,
                                    styles.subHeaderText,
                                    { marginTop: 40 }
                                ]}>You will be charged <Text style={[FontStyles.dark]}>₦10.75</Text> amount for this transaction.</Text>

                                <StyledButton
                                    label="Send"
                                    color={'default'}
                                    size="lg"
                                    style={{ marginTop: 16 }}
                                    submitting={isSubmitting}
                                    disabled={isSubmitting}
                                    action={submitForm}
                                />
                            </View>
                        </View>}
                    </Formik>
                    : null
                }
            </ScrollView>
        </>
    )
}

export default SendStartScreen

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.shades._5,
    },
    subHeader: {
        paddingHorizontal: 16,
        paddingBottom: 16,
        paddingTop: 0,
        borderBottomColor: Colors.shades._6,
        borderBottomWidth: 1,
        borderStyle: 'solid',
        backgroundColor: Colors.whiteColor
    },
    subHeaderText: {},
    formContainer: {
        backgroundColor: Colors.whiteColor,
        paddingHorizontal: 16,
        paddingBottom: 30,
        borderTopColor: Colors.shades._6,
        borderBottomColor: Colors.shades._6,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderStyle: 'solid',
    },
    starWrapper: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', marginTop: 58 },
    star: { width: 24, height: 28, marginHorizontal: 4 },
})